
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiRisorseDialog extends Serenity.EntityDialog<ProdottiRisorseRow, any> {
        protected getFormKey() { return ProdottiRisorseForm.formKey; }
        protected getIdProperty() { return ProdottiRisorseRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiRisorseRow.localTextPrefix; }
        protected getService() { return ProdottiRisorseService.baseUrl; }
        protected getDeletePermission() { return ProdottiRisorseRow.deletePermission; }
        protected getInsertPermission() { return ProdottiRisorseRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiRisorseRow.updatePermission; }

        protected form = new ProdottiRisorseForm(this.idPrefix);

    }
}